import FJImageEnhancerLeft from './FJImageEnhancerLeft.jsx';
import { useDispatch, useSelector } from 'react-redux';
import useLocalStore from '../../../hooks/useLocalStore';
import { setSliceZoomAction } from '../../../redux/slices/FJSliceImageEnhancer.js';
import FJUtil from '../../../util/FJUtil.js';
import FJActionImageEnhancer from '../../../redux/action/FJActionImageEnhancer.js';
import { useCallback } from 'react';
import FJActionCommon from '../../../redux/action/FJActionCommon.js';

const FJImageEnhancerLeftContainer = () => {
    useLocalStore();
    const dispatch = useDispatch();
    const upscale = useSelector(state => state.imageEnhancer.upscale);
    const taskStatus = useSelector(state => state.common.taskStatus);
    const creditNumber = useSelector(state => state.common.creditNumber);
    const freeNumCreation = useSelector(state => state.common.freeNumCreation);
    const isProjectLoading = useSelector(state => state.common.isProjectLoading);
    const uploadImageList = useSelector(state => state.imageEnhancer.uploadImageList);

    const _onChangeZoom = value => {
        dispatch(setSliceZoomAction(value));
    };
    const _onGenerate = useCallback(() => {
        if (FJUtil.isGeneratingStatus(taskStatus)) return;
        dispatch(FJActionImageEnhancer.generateAction());
        dispatch(FJActionCommon.setHeaderTabIndexAction(0));
    }, [dispatch, taskStatus]);
    return (
        <FJImageEnhancerLeft
            upscale={upscale}
            onChangeZoom={_onChangeZoom}
            isProjectLoading={isProjectLoading}
            onGenerate={_onGenerate}
            taskStatus={taskStatus}
            freeNumCreation={freeNumCreation}
            creditNumber={creditNumber}
            uploadImageList={uploadImageList}
        />
    );
};

export default FJImageEnhancerLeftContainer;
